import { useEffect } from "react";
import * as Bananas from "bananas-commerce-admin";

export const Redirect = () => {
  const { navigate } = Bananas.useRouter();
  const { user } = Bananas.useUser();
  useEffect(() => {
    const isMediaUser = user?.groups
      .map((group) => group.toLowerCase())
      .includes("mediauser");

    if (isMediaUser) {
      navigate("mediahouse.publications:get");
    } else {
      navigate("case.case:list");
    }
  }, [navigate, user]);
  return null;
};
